export function PlayRoundIcon(props) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill={props.color || "#FFF"} fillRule="evenodd">
        <path d="M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0024 0zm0 44.571c-11.361 0-20.571-9.21-20.571-20.571S12.639 3.429 24 3.429 44.571 12.639 44.571 24A20.571 20.571 0 0124 44.571z" />
        <path d="M20 14l13.419 10L20 34z" />
      </g>
    </svg>
  );
}

function PlayIcon(props) {
  return (
    <svg width={48} height={48} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#FFF" fillRule="evenodd">
        <path d="M20 14l13.419 10L20 34z" />
      </g>
    </svg>
  );
}

export default PlayIcon;
